import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import PanelLoadingIndicator from "../components/PanelLoadingIndicator";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import ProgramTable from "./ProgramTable";
import { compose, prop, sortBy, toLower } from "ramda";
import TotalsHeader from "../creator-application/common/TotalsHeader";
import { Box } from "@material-ui/core";
import { isBlank, notBlank } from "../util/ext";
import { useHistory, useLocation } from "react-router-dom";
import NewProgramDialog from "./edit/NewProgramDialog";

const useStyles = scrollVisible =>
  makeStyles(theme => ({
    root: {
      border: "3px white solid",
      backgroundColor: "white",
      borderRadius: "20px",
    },

    panel: {
      backgroundColor: "white",
      paddingLeft: theme.spacing(4),
      paddingRight: scrollVisible ? theme.spacing(0) : theme.spacing(4),
      minHeight: "calc(100vh - 500px)",
    },
  }));

const ProgramBrowseView = ({ programsResponse }) => {
  const history = useHistory();
  const location = useLocation();

  const [scrollVisible, setScrollVisible] = useState(true);
  const classes = useStyles(scrollVisible)();

  const [dialogOpen, setDialogOpen] = useState(false);

  const [sortedPrograms, setSortedPrograms] = useState([]);
  useEffect(() => {
    if (programsResponse.isSuccess) {
      setScrollVisible(true);
      const sortedPrograms = sortBy(
        compose(toLower, prop("programName")),
        programsResponse.data,
      );
      setSortedPrograms(sortedPrograms);
    }
  }, [programsResponse.data, programsResponse.isSuccess]);

  const handleScrollVisible = useCallback(visible => {
    setScrollVisible(visible);
  }, []);

  const handleNewProgramClicked = useCallback(value => {
    setDialogOpen(true);
  }, []);

  const handleNewCancel = useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleNewSave = useCallback(
    data => {
      setDialogOpen(false);
      history.push(`/manage-csp/programs/${data.programId}`, {
        previousLocation: location.pathname,
      });
    },
    [history, location.pathname],
  );

  return (
    <Container id="program-browse-view" classes={{ root: classes.root }}>
      <div>
        <TotalsHeader
          countText="Program"
          count={programsResponse.isSuccess ? sortedPrograms.length : 0}
          selectedActions={
            <Box>
              <Button
                variant={"text"}
                startIcon={<AddIcon />}
                onClick={handleNewProgramClicked}
              >
                New Program
              </Button>
            </Box>
          }
        />
        <Container classes={{ root: classes.panel }}>
          {programsResponse.isError && (
            <Box padding={5} color="error" fontSize="1.4rem" fontStyle="italic">
              Error loading Programs.
            </Box>
          )}
          {programsResponse.isLoading && <PanelLoadingIndicator />}
          {programsResponse.isSuccess && isBlank(sortedPrograms) && (
            <Box padding={5} fontSize="1.4rem" fontStyle="italic">
              No Programs have been created.
            </Box>
          )}
          {programsResponse.isSuccess && notBlank(programsResponse) && (
            <ProgramTable
              programs={sortedPrograms}
              onScrollVisible={handleScrollVisible}
            />
          )}
        </Container>
      </div>

      {dialogOpen && (
        <NewProgramDialog
          open={dialogOpen}
          onCancel={handleNewCancel}
          onApply={handleNewSave}
        />
      )}
    </Container>
  );
};

export default ProgramBrowseView;
